<template>
  <h2 class="form-title">Edit FAQ</h2>
  <VeeForm class="table-shadow faq-form" @submit="editFAQ">
    <Field v-slot="{ field, errors, meta }" :model-value="question" name="question" :rules="rules.question">
      <div class="form-group">
        <label class="required fs-xl mt-0">Question</label>
        <div class="input-group">
          <input
            v-bind="field"
            v-model="question"
            :class="['form-control', getValidationState(meta)]"
            type="text"
            placeholder="Question"
          />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </div>
    </Field>

    <Field v-slot="{ field, errors, meta }" :model-value="answer" name="answer" :rules="rules.answer">
      <div class="form-group">
        <label class="required fs-xl mt-0">Answer</label>
        <div class="input-group">
          <input
            v-bind="field"
            v-model="answer"
            :class="['form-control', getValidationState(meta)]"
            type="text"
            placeholder="Answer"
          />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </div>
    </Field>

    <div class="form-group mt-4 mb-0">
      <button type="submit" class="btn create-btn btn-green">Update question</button>
    </div>
  </VeeForm>
</template>

<script lang="ts">
import { Form as VeeForm, Field } from 'vee-validate'
import { ref, computed, defineComponent, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getValidationState } from '@/services/Validation'
import { useAccountStore } from '@/store/account'
import { useFaqStore } from '@/store/faq'
import { FAQ_LIST } from '@/types/router'

export default defineComponent({
  name: 'FAQCreate',
  components: { Field, VeeForm },
  setup() {
    const accountStore = useAccountStore()
    const faqStore = useFaqStore()
    const route = useRoute()
    const router = useRouter()
    const question = ref('')
    const answer = ref('')

    const rules = {
      question: 'required|min:3',
      answer: 'required|min:3',
    }

    const isStaff = computed(() => accountStore.isStaff)
    const faqId = computed(() => route.params.id)

    const editFAQ = async () => {
      await faqStore.updateQuestion({
        id: faqId.value as string,
        data: {
          question: question.value,
          answer: answer.value,
        },
      })
      await router.push({ name: FAQ_LIST })
    }
    const loadFAQ = async () => {
      const data = await faqStore.fetchQuestion(faqId.value as string)
      question.value = data.question
      answer.value = data.answer
    }

    onMounted(() => {
      if (!isStaff.value) {
        router.push({ name: FAQ_LIST })
      }
      loadFAQ()
    })

    watch(faqId, loadFAQ)

    return {
      question,
      answer,
      rules,
      isStaff,
      editFAQ,
      getValidationState,
    }
  },
})
</script>
